import { useQuery } from "@tanstack/vue-query";
import { STALE } from "ls/queries/staleTime";
import { computed } from "vue";
import { queries } from "./queries";

export function usePrivateWorkspace() {
  const query = useQuery({
    ...queries.list(),
    staleTime: STALE.INFINITY,
  });

  const privateWorkspace = computed(() => query.data.value?.Filesystems.find(w => w.IsDefaultFs));
  return privateWorkspace;
}
